module.exports = __webpack_public_path__ + "img/GiftCards.a66d02db.png";